import React, { useState } from 'react';
import { Formik, Form } from 'formik';
import { useHistory } from 'react-router';
import * as Yup from 'yup';
import Box from '@material-ui/core/Box';
import { LOGOUT } from 'ConstComponents';
import { SenderRegistration as SENDER_ADD } from 'Components/Api/PayPointAPI';
import { useLocation } from 'react-router-dom';
import { MaterialNumberField } from 'Components/Inputes/FormikMaterialNumberInput';
import { Container, Grid, Paper, Button, Typography } from '@material-ui/core';
import CircularProgress from '@material-ui/core/CircularProgress';
import { commonStyle } from 'Components/CustomMaterialStyleSheets/CommonStyleSheet';
import { PLEASE_PROVIDE_VALID } from 'Components/Helper/Messages';
import HOCLoader from 'Components/Loader/HOCLoader';
import { PRIMARY_COLOR } from 'Config';
import { makeStyles } from '@material-ui/core/styles';
import { MaterialTextField } from 'Components/Inputes/FormikMaterialInput';

const CustomContainer = HOCLoader(Container);

const useStyles = makeStyles((theme) => ({
    paper: {
        padding: theme.spacing(3),
        textAlign: 'center',
        backgroundColor: '#f8f8f8',
        borderRadius: '10px',
        border: '1px solid #ccc',
        width: '50%',
        justifyContent: 'center'
    },
    header: {
        color: 'red',
        fontWeight: 'bold'
    },
    content: {
        marginTop: theme.spacing(2),
        marginBottom: theme.spacing(2),
        textAlign: 'left'
    },
    button: {
        backgroundColor: '#4CAF50',
        width: '70%',
        color: 'white',
        marginTop: theme.spacing(2),
        '&:hover': {
            backgroundColor: PRIMARY_COLOR
        }
    }
}));

const PayPointSenderAdd = () => {
    const classes = commonStyle();
    const history = useHistory();
    const location = useLocation();
    const ActivePPIName = location?.state?.DMTName;
    const [responseMessage, setResponseMessage] = useState('');
    const [isError, setIsError] = useState(false);
    const [loading, setLoading] = useState(false);
    const [severity, setSeverity] = useState('success');
    const [formObject, setFormObject] = useState({
        Mobile: '',
        Name: ''
    });

    const submithandle = async (values, { setSubmitting, resetForm }) => {
        var request = {
            DMTName: ActivePPIName,
            Mobile: values.Mobile
        };
        var requestObj = JSON.stringify(request);

        setLoading(true);
        setIsError(false);

        var response = await SENDER_ADD(requestObj); 
        setLoading(false);
        if (!response.isAuthorized) {
            LOGOUT();
        }

        if (!response.status) {
            setIsError(true);
            setSeverity('error');
            setResponseMessage(response.data);
            return;
        }

        var data = JSON.parse(response.data); 
        setResponseMessage(data.Message);
        setSeverity('success');
        setIsError(true);
        let params = {
            Mobile: values.Mobile,
            SenderID: data.SenderID,
            OTPRefID: data.OTPRefID,
            PinCode: data.PinCode,
            Name: data.Name,
            DMTName: ActivePPIName
        }; 
        history.push('/PPIVerifySenderOTP', params, data.OTPRefID);
    };

    const FormValidationSchema = Yup.object({
        Mobile: Yup.string().required(PLEASE_PROVIDE_VALID + 'mobile'),
    });

    return (
        <CustomContainer
            isLoading={loading}
            isError={isError}
            alertMessage={responseMessage}
            severity={severity}
            onCloseCallback={(alertState) => {
                setIsError(alertState);
            }}
        >
            <Formik
                enableReinitialize={true}
                initialValues={formObject}
                validationSchema={FormValidationSchema}
                onSubmit={submithandle}
                resetForm={formObject}
                render={({ values, setFieldValue }) => {
                    return (
                        <Form>
                            <Grid
                                item
                                container
                                margin="normal"
                                xs={12}
                                md={12}
                                sm={12}
                                lg={12}
                                spacing={2}
                                style={{ justifyContent: 'center' }}
                            >
                                <Grid item xs={12} sm={12} md={4} lg={4}>
                                    <h2 className={classes.PaperHead_h2}>
                                        Sender Add
                                    </h2>
                                    <Grid item xs={12}>
                                        <Paper className={classes.PaperStyle}>
                                            <Grid container spacing={2}>

                                                <Grid
                                                    xs={12}
                                                    sm={12}
                                                    md={12}
                                                    lg={12}
                                                    style={{ marginBottom: '16px' }}
                                                >
                                                    <MaterialNumberField
                                                        label="Mobile"
                                                        name="Mobile"
                                                        type="Mobile"
                                                        length={10}
                                                        placeholder="Mobile"
                                                    />

                                                </Grid>
                                            </Grid>
                                        </Paper>
                                    </Grid>
                                    <Grid className={classes.footerGrid}>
                                        <Box className={classes.flexReverse}>
                                            <div className={classes.SubmitWrapper}>
                                                <Button
                                                    type="submit"
                                                    title="Add"
                                                    className={
                                                        classes.CustomPrimaryButtonStyle
                                                    }
                                                    disabled={loading}
                                                >
                                                    Add
                                                </Button>
                                                {loading && (
                                                    <CircularProgress
                                                        size={24}
                                                        className={
                                                            classes.buttonProgress
                                                        }
                                                    />
                                                )}
                                            </div>
                                            <Button
                                                type="reset"
                                                title="Reset"
                                                className={
                                                    classes.CustomDangerButtonStyle
                                                }
                                            >
                                                Reset
                                            </Button>
                                        </Box>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Form>
                    );
                }}
            />
        </CustomContainer >
    );
};
export default PayPointSenderAdd;
